import { CgCheck } from "react-icons/cg";
import { GetServerParsedName } from "../../../../../../../Services/Servers/ServerHelper";

const AddServerPanel = ({server, ChangeSelection}) => {
    return (
        <div className="serverPanel flex">
            <div dangerouslySetInnerHTML={{__html: GetServerParsedName(server.name)}}/>
            <input type="checkbox" onChange={() => ChangeSelection(server.id)}/>
        </div>
    )
}
export default AddServerPanel;